module.exports = __webpack_public_path__ + "static/media/digital.f8757d52.png";